import React from "react";

import "./InputField.css";

type InputFieldProps = {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  error?: string;
  className?: string;
};

const InputField: React.FC<InputFieldProps> = ({
  label,
  name,
  value,
  onChange,
  required = false,
  error,
  className,
}) => {
  return (
    <div className={`custom-input ${className}`}>
      <label>
        {label} {required && <span className="text-red">*</span>}
      </label>
      <input
        name={name}
        value={value}
        onChange={onChange}
        className={`${error ? "border-red" : ""}`}
      />
    </div>
  );
};

export default InputField;
